import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/about/meetup')({
  component: RouteComponent,
})

function RouteComponent() {
  return <div>Hello "/about/meetup"!</div>
}
